module.exports = __webpack_public_path__ + "static/media/logo.655300a0.png";